import classNames from 'classnames';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import { useDropzone } from 'react-dropzone';
import styles from './style.module.scss';

const FileUploader = ({
  onDrop,
  isLoading
}: {
  onDrop: (acceptedFiles: File[]) => void;
  isLoading: boolean;
}) => {
  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    noClick: true
  });

  const rootProps = getRootProps();
  const inputProps = getInputProps();

  return (
    <div
      className={classNames(
        'h-64 flex flex-col border-dashed border-2 rounded-lg',
        ...(isDragActive
          ? ['border-primary-500 bg-primary-50']
          : ['border-gray-200 bg-gray-50'])
      )}
      onBlur={rootProps.onBlur}
      onClick={rootProps.onClick}
      onDragEnter={rootProps.onDragEnter}
      onDragLeave={rootProps.onDragLeave}
      onDragOver={rootProps.onDragOver}
      onDrop={rootProps.onDrop}
      onFocus={rootProps.onFocus}
      onKeyDown={rootProps.onKeyDown}
      ref={rootProps.ref}
      role={rootProps.role}
      tabIndex={rootProps.tabIndex}
    >
      <input
        accept={inputProps.accept}
        multiple={inputProps.multiple}
        disabled={isLoading}
        onChange={inputProps.onChange}
        onClick={inputProps.onClick}
        style={inputProps.style}
        tabIndex={inputProps.tabIndex}
        type={inputProps.type}
      />
      <div className="flex-1 flex flex-col items-center justify-center">
        {isLoading ? (
          <div className="flex-1 flex flex-col items-center justify-center">
            <Spinner type={SpinnerType.PRIMARY} />
          </div>
        ) : (
          <>
            <h3 className="text-[24px]">
              Drag and drop your files here, or{' '}
              <a
                onClick={open}
                className={classNames('text-2xl', styles['dark-blue'])}
              >
                browse
              </a>
            </h3>
            <p className="mt-4 text-[14px] text-gray-600 font-normal">
              Accepted file types: JPG and PNG up to 100MB
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
